export default "__VITE_ASSET__BtG30J_I__"